import { combineEpics } from 'redux-observable'
import storyEpic from './storyEpic'
import storyUpdateEpic from './storyUpdateEpic'
import saveStoryEpic from './saveStoryEpic'
import toastrEpic from './toastrEpic'
import toolbarEpic from './toolbarEpic'
import webskedDisabledListenerEpic from './webskedDisabledListenerEpic'
import storyPreviewEpic from './storyPreviewEpic'
import goToLiveStoryEpic from './goToLiveStoryEpic'
import storyDirtyEpic from './storyDirtyEpic'
import deleteStoryEpic from './deleteStoryEpic'
import webskedTasksEpic from './webskedTasksEpic'
import webskedNewTaskEpic from './webskedNewTaskEpic'
import webskedPitchesEpic from './webskedPitchesEpic'
import webskedNewPitchEpic from './webskedNewPitchEpic'
import webskedCollectionsEpic from './webskedCollectionsEpic'
import webskedAddCollectionsEpic from './webskedAddCollectionsEpic'
import addRelatedContentEpic from './addRelatedContentEpic'
import sendToPrintEpic from './sendToPrintEpic'
import tansaIntegrationEpic from './tansaIntegrationEpic'
import storyAutoSaveEpic from './storyAutoSaveEpic'
import pharosCrumbsEpic from './pharosCrumbsEpic'
import settingsSyncEpic from './settingsSyncEpic'
import customColorsEpic from './customColorsEpic'
import denormalizeRelatedContentEpic from './denormalizeRelatedContentEpic'
import getNgStoryEpic from './getNgStoryEpic'
import setNgStoryEpic from './setNgStoryEpic'
import { validateSettingsEpic } from './storyPublishEpic'
import connectivityEpic from './connectivityEpic'
import picklistsEpic from './picklistsEpic'

export default combineEpics(
  storyEpic,
  storyUpdateEpic,
  saveStoryEpic,
  toastrEpic,
  toolbarEpic,
  webskedDisabledListenerEpic,
  storyPreviewEpic,
  goToLiveStoryEpic,
  storyDirtyEpic,
  deleteStoryEpic,
  webskedTasksEpic,
  webskedNewTaskEpic,
  webskedPitchesEpic,
  webskedNewPitchEpic,
  webskedCollectionsEpic,
  webskedAddCollectionsEpic,
  addRelatedContentEpic,
  sendToPrintEpic,
  tansaIntegrationEpic,
  storyAutoSaveEpic,
  pharosCrumbsEpic,
  settingsSyncEpic,
  customColorsEpic,
  denormalizeRelatedContentEpic,
  validateSettingsEpic,
  getNgStoryEpic,
  setNgStoryEpic,
  connectivityEpic,
  picklistsEpic
)
